export default {
  en: {
    contacts: {
      title: 'Contact Us',
      text: 'If you have suggestions for collaboration or improving the service, write to us:',
      tg: 'User Support Telegram Channel',
      whatsapp: 'WhatsApp Support Chat',
    },
    subscribe: {
      text: 'Subscribe to stay updated on platform news and updates:',
      tg: 'News Telegram Channel',
      vk: 'VK Group',
      gx: 'Glabix Blog',
    },
    screen: {
      title: 'Glabix.Screen',
      gettingStarted: {
        title: 'Getting Started',
        item1: 'How to install Glabix.Screen',
        item2: 'How to record a video message',
        item3: 'Video message features',
      },
      editor: {
        title: 'Editor',
        item1: 'Video editing',
        item2: 'How to upload a video cover',
        item3: 'How to create promo buttons',
      },
      library: {
        title: 'Library and Access',
        item1: 'Library of video messages',
        item2: 'Access to video messages',
      },
      readMore: 'Go to Glabix.Screen knowledge base',
    },
    letuchka: {
      title: 'Glabix.Letuchka',
      organization: {
        title: 'Organization',
        item1: 'How to create an organization',
        item2: 'How to invite users',
        item3: 'List of users',
        item4: 'Roles and access rights',
        item5: 'How to delete an organization',
      },
      tasks: {
        title: 'Tasks',
        item1: 'How to create a task',
        item2: 'How to display a task',
        item3: 'How to create a task',
        item4: 'How to create a task',
        item5: 'What is a task block?',
      },
      letuchka: {
        title: 'Letuchka',
        item1: 'Global and project Letuchka',
        item2: 'How to add a task or a subtask to Letuchka',
        item3: 'Incoming tasks',
        item4: 'Blocking',
      },
      readMore: 'Go to Glabix.Letuchka knowledge base',
    },
  },
  ru: {
    contacts: {
      title: 'Связь с нами',
      text: 'Если у вас есть предложения по сотрудничеству или по улучшению сервиса, напишите нам:',
      tg: 'Telegram канал поддержки пользователей',
      whatsapp: 'WhatsApp чат поддержки пользователей',
    },
    subscribe: {
      text: 'Подпишитесь на нас, чтобы быть в курсе новостей и обновлений платформы:',
      tg: 'Новостной Telegram канал',
      vk: 'Группа Вконтакте',
      gx: 'Блог Глабикс',
    },
    screen: {
      title: 'Глабикс.Экран',
      gettingStarted: {
        title: 'Начало работы',
        item1: 'Как установить Глабикс.Экран',
        item2: 'Как записать видеосообщение',
        item3: 'Возможности видеосообщения',
      },
      editor: {
        title: 'Редактор',
        item1: 'Редактирование видео',
        item2: 'Как загрузить обложку видео',
        item3: 'Как создать промокнопки',
      },
      library: {
        title: 'Библиотека и доступы',
        item1: 'Библиотека видеосообщений',
        item2: 'Доступы к видеосообщениям',
      },
      readMore: 'Перейти в базу знаний Глабикс.Экран',
    },
    letuchka: {
      title: 'Глабикс.Летучка',
      organization: {
        title: 'Организация',
        item1: 'Создание организации',
        item2: 'Приглашение сотрудников',
        item3: 'Список сотрудников',
        item4: 'Роли и права доступа',
        item5: 'Удаление организации',
      },
      tasks: {
        title: 'Задачи',
        item1: 'Создание задачи',
        item2: 'Виды отображения задачи',
        item3: 'Сайдбар задачи',
        item4: 'Информация о задаче',
        item5: 'Что такое блоки задачи?',
      },
      letuchka: {
        title: 'Летучка',
        item1: 'Глобальная и проектная Летучка',
        item2: 'Как добавить задачу или подзадачу в Летучку',
        item3: 'Входящие задачи',
        item4: 'Блокировка',
      },
      readMore: 'Перейти в базу знаний Глабикс.Летучка',
    },
  },
}
